import Header from "./sections/header/Header";
// import Navbar from "./sections/navbar/Navbar";
import Project from "./sections/project/Project";
import Experiences from "./sections/experiences/Experiences";
import Contact from "./sections/contact/Contact";

const App = () => {
  return (
    <main>
      <Header />
      <Experiences />
      <Project />
      <Contact />
    </main>
  );
};

export default App;
